import { Heading } from "@/components/ui/heading.jsx";
import { Head } from "@inertiajs/react";
import pageTitle from "@/utils/pageTitle.js";
import ProductsSelection from "@/components/products/ProductsSelection.jsx";

export default function (props) {
  return (
    <div className={"container mx-auto space-y-8 py-16 px-4 xl:px-0"}>
      <Head title={pageTitle("Услуги")}></Head>
      <Heading size={"h1"}>Услуги</Heading>
      <div className="space-y-8">

        <div>
          <Heading size={"h2"} id="fotozoni">
            Фотозоны
          </Heading>

          <ProductsSelection selection={props.selections[0]} />
          <div className="prose prose-lg max-w-none">
            <p>
              Предварительные выводы неутешительны: синтетическое тестирование
              создаёт необходимость включения в производственный план целого
              ряда внеочередных мероприятий с учётом комплекса вывода текущих
              активов. Кстати, непосредственные участники технического прогресса
              заблокированы в рамках своих собственных рациональных ограничений.
              Равным образом, реализация намеченных плановых заданий влечет за
              собой процесс внедрения и модернизации глубокомысленных
              рассуждений.
            </p>
          </div>
        </div>

        <div>
          <Heading size={"h2"} id="decor">
            Изготовление декораций
          </Heading>
          <div className="prose prose-lg max-w-none">
            <p>
              Предварительные выводы неутешительны: синтетическое тестирование
              создаёт необходимость включения в производственный план целого
              ряда внеочередных мероприятий с учётом комплекса вывода текущих
              активов. Кстати, непосредственные участники технического прогресса
              заблокированы в рамках своих собственных рациональных ограничений.
              Равным образом, реализация намеченных плановых заданий влечет за
              собой процесс внедрения и модернизации глубокомысленных
              рассуждений.
            </p>
          </div>
        </div>

        <div>
          <Heading size={"h2"} id="banners">
            Печать баннеров и плакатов
          </Heading>
          <div className="prose prose-lg max-w-none">
            <p>
              Предварительные выводы неутешительны: синтетическое тестирование
              создаёт необходимость включения в производственный план целого
              ряда внеочередных мероприятий с учётом комплекса вывода текущих
              активов. Кстати, непосредственные участники технического прогресса
              заблокированы в рамках своих собственных рациональных ограничений.
              Равным образом, реализация намеченных плановых заданий влечет за
              собой процесс внедрения и модернизации глубокомысленных
              рассуждений.
            </p>
          </div>
        </div>

        <div>
          <Heading size={"h2"} id="biznes">
            Оформление вашего бизнеса
          </Heading>
          <ProductsSelection selection={props.selections[1]} />
          <div className="prose prose-lg max-w-none">
            <p>
              Предварительные выводы неутешительны: синтетическое тестирование
              создаёт необходимость включения в производственный план целого
              ряда внеочередных мероприятий с учётом комплекса вывода текущих
              активов. Кстати, непосредственные участники технического прогресса
              заблокированы в рамках своих собственных рациональных ограничений.
              Равным образом, реализация намеченных плановых заданий влечет за
              собой процесс внедрения и модернизации глубокомысленных
              рассуждений.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
